import { lazy } from "react";
// Clinical Data Collector — captura de datos clínicos y generación de reportes.
const ClinicalDataCollectorPage = lazy(() => import("./ClinicalDataCollectorPage"));
const ReportPage = lazy(() => import("./ReportPage"));
const ReportGeneratorPage = lazy(() => import("./ReportGeneratorPage"));
export const clinicalDataCollectorRoutes = [
  { path: "/ClinicalDataCollectorPage", element: <ClinicalDataCollectorPage /> },
  { path: "/report", element: <ReportPage /> },
  { path: "/ReportGeneratorPage", element: <ReportGeneratorPage /> },
];

export { ClinicalDataCollectorPage, ReportPage, ReportGeneratorPage };
